import { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import { screenSmMin } from 'styles-js/mediaQueries';

export function useWindowSize() {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = throttle(() => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }, 1000);

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return size;
}

export function useIsMobile() {
  return useWindowSize().width < screenSmMin;
}
